var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyCustomerManagementSearch = function SvgImgEmptyCustomerManagementSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    transform: "translate(7 19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.066 15.625h5.868a6.72 6.72 0 0 1 6.703 6.25l.363 5.18a1 1 0 0 1-.997 1.07H.997A1 1 0 0 1 0 27.055l.363-5.18a6.72 6.72 0 0 1 6.703-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5 23.75.715 3.681m9.166-3.681-.715 3.681"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.875,
    r: 6.875
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    transform: "translate(53 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.066 15.625h5.868a6.72 6.72 0 0 1 6.703 6.25l.363 5.18a1 1 0 0 1-.997 1.07H.997A1 1 0 0 1 0 27.055l.363-5.18a6.72 6.72 0 0 1 6.703-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5 23.75.715 3.681m9.166-3.681-.715 3.681"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.875,
    r: 6.875
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    transform: "translate(30 34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.066 15.625h5.868a6.72 6.72 0 0 1 6.703 6.25l.363 5.18a1 1 0 0 1-.997 1.07H.997A1 1 0 0 1 0 27.055l.363-5.18a6.72 6.72 0 0 1 6.703-6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5 23.75.715 3.681m9.166-3.681-.715 3.681"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.875,
    r: 6.875
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 40)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 19.422 3.176-3.176 12.02 12.02a2 2 0 0 1 0 2.83l-.347.346a2 2 0 0 1-2.828 0L15 19.422z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 12.5A6.5 6.5 0 0 0 12.5 6"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyCustomerManagementSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-customer-management-search.eb206ecc2fa44de1c51c8d1337ca8b69.svg";